import script from "./historyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./historyModal.vue?vue&type=script&setup=true&lang=js"

import "./historyModal.vue?vue&type=style&index=0&id=3f84c923&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f84c923"]])

export default __exports__